import React, { useEffect } from 'react'
import styled from 'styled-components'
import {
    hexToRgbA,
    keyEscHandler,
    triggerItemDownloadAnalytics,
    triggerItemStoreAnalytics
} from '../../../App/Utils/utils'
import { Dark, Dark4, Gray60, WerfenColor, White, } from '../../Constants/ColorChart'
import isElectron from 'is-electron'
import FeatherIconWrapper from "../Icons/FeatherIconWrapper";
import DeleteIcon from "../Icons/Delete/Delete";
import LikeIcon from "../LikeIcon/LikeIcon";
import AvailableOfflineIndicator from "../AvailableOfflineIndicator/AvailableOfflineIndicator";
import DownloadIcon from "../Icons/Download/Download";
import PDFViewer from "../PDFViewer/PDFViewer";
import getMediaDownloadToken from "../FileDownload/GetMediaDownloadToken";
import { showDialog } from "../../../actions/ui";
import { connect } from "react-redux";

let electron;

if ( isElectron () ) {
    electron = window.require ( "electron" )
}
const ipcRenderer = electron && electron.ipcRenderer;

/*
 *  @Description:   Component that shows a PDF passed by props (doc).
 *                  
 */


const Title = styled.div`
    margin-top: auto;
    margin-bottom: auto;
`;

const ActionsDiv = styled.div`
    position: absolute;
    margin-top: 5px;
    right: 30px;
`;

const Bar = styled.div`
    
    background: ${ Dark };
    display: flex;
    z-index: 5;
    height: 50px;
    width: 100%;
    ${ props => props.position === "top" && "top: 0px;" }
    ${ props => props.position === "bottom" && `bottom: ${ props.isDownloadManagerOpened ? "99" : "0" }px;` }
`;

const Wrapper = styled.div`
    background: ${ Gray60 };
    position: fixed;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    color: ${ White };
    z-index: 3;
`;

const DocumentView = ( props ) => {
    const { doc, fileName } = props;

    useEffect ( () => {
        window.addEventListener ( 'keydown', onKeyDown )
        document.body.style.overflowY = 'hidden';

        if ( isElectron () ) {
            ipcRenderer.send ( "getDownloadManagerStatus", null )
        }
        return () => {
            window.removeEventListener ( 'keydown', onKeyDown )
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );

    const onKeyDown = ( event ) => {
        keyEscHandler ( ( event ), handleClose )
    }

    const handleClose = () => {
        props.clearDocument ();
        document.body.style.overflowY = 'auto';
    }

    const storeResource = (resource) => {
        resource.sessionToken = props.session.token;
        ipcRenderer.invoke('CreateResource', resource);

        const info = {
            id: resource.id,
            name: resource.metadata.name,
            type: resource.type,
            index: resource.metadata.fileIndex
        };

        triggerItemStoreAnalytics(info, props.session.user);
    }

    const saveAs = ( event, doc ) => {
        event.preventDefault ();
        event.stopPropagation ();
        // console.info( "'saveAs' receives 'doc':", doc );
        const { isNetworkAvailable /*, isServerReachable */ } = props;
        // noinspection UnnecessaryLocalVariableJS
        const canConnect = isNetworkAvailable // && isServerReachable;
        if ( canConnect ) {
            const info = { id: doc.id, name: doc.metadata.name, index: doc.metadata.fileIndex };
            triggerItemDownloadAnalytics ( info );

            getMediaDownloadToken ( doc.media_uuid, props.session.token, ( mediaDownloadToken ) => {
                if ( mediaDownloadToken !== null && mediaDownloadToken !== "null" ) {
                    let link = document.createElement ( 'a' );
                    // noinspection JSUndefinedPropertyAssignment
                    // console.log( { doc } );
                    link.download = doc.metadata.filename;
                    // noinspection JSUndefinedPropertyAssignment
                    link.href = doc.url + '/' + mediaDownloadToken;
                    link.click ();
                    // console.info( "Link:", link );
                    link.remove ();
                } else {
                    showDialog ( {
                        dialogTitle: "Resource Unavailable",
                        dialogBody: [ "The resource ", doc.metadata.name, " isn't available!" ],
                    } )
                }
            } )
                .catch ( ( error ) => {
                    console.error ( "Error with getMediaDownloadToken promise: ", error );
                } );
        } else {
            let link = document.createElement ( 'a' );
            // noinspection JSUndefinedPropertyAssignment
            link.download = doc.metadata.filename;
            // noinspection JSUndefinedPropertyAssignment
            link.href = doc.url;
            link.click ();
            // console.info( "Link:", link );
            link.remove ();
        }
    }

    return (
        <Wrapper>
            <Bar position="top">
                <FeatherIconWrapper
                    color={ White }
                    fillColor={ White }
                    width="25px"
                    iconStyle="margin-left: 30px; margin-right:30px; &:hover{cursor:pointer}"
                    Icon={ DeleteIcon }
                    onClick={ () => handleClose () }
                />
                <Title>{ decodeURIComponent ( fileName ) }</Title>
                <ActionsDiv>
                    <LikeIcon
                        color={ Dark4 }
                        width="25px"
                        activeStyle={ `margin: 5px; fill: ${ Dark4 }; stroke: ${ Dark }; cursor: pointer;` }
                        unactiveStyle="margin: 5px; cursor: pointer;"
                        active={ doc && doc.actions && doc.actions.like }
                        itemId={ doc.id }
                        likeId={ doc.likeId }
                        entityBundle={ doc.metadata.entityBundle }
                    />
                    { isElectron () &&

                        <AvailableOfflineIndicator
                            color={ WerfenColor }
                            fillColor={ White }
                            width="25px"
                            activeStyle={ `margin:5px; fill: ${ White }; stroke: ${ Dark }` }
                            unactiveStyle={ `margin:5px; fill: none; stroke: ${ White }; cursor: pointer` }
                            transitionColors={ [ WerfenColor, hexToRgbA ( WerfenColor, 0.5 ) ] }
                            active={ doc.actions.isDownloaded }
                            onClick={ () => !doc.actions.isDownloaded && storeResource ( doc ) }
                            itemId={ doc.id }
                            isActive={ doc.actions.isDownloaded && !doc.isDownloading }
                            isDownloading={ doc.isDownloading }
                        />
                    }
                    {
                        doc &&
                        doc.saveAs &&

                        <FeatherIconWrapper
                            color={ White }
                            iconStyle={ `margin: 5px;` }
                            fillColor={ "none" }
                            width="25px"
                            onClick={ ( event ) => saveAs ( event, doc ) }
                            Icon={ DownloadIcon }
                        />
                    }
                </ActionsDiv>
            </Bar>
            <PDFViewer id="pdfViewer" src={ doc.file } handleClose={ handleClose }
                       isDownloaded={ false }/>
        </Wrapper>
    )

}
const mapStateToProps = ( state ) => ( {
    isNetworkAvailable: state.sensors.isNetworkAvailable,
    isServerReachable: state.sensors.isServerReachable,
    session: state.session,
} )

export default connect ( mapStateToProps, {} ) ( DocumentView );